module.exports = __webpack_public_path__ + "img/surat-add-penduduk-min.94c8ca95.png";